import styled from 'styled-components'

import { styleMixins } from '../../../style'
import { getDefaultBeatifiedScrollbar } from '../../../style/styleMixins/other'

const { opacityColor } = styleMixins.color
const { getSpacing } = styleMixins.offset

export const SPanelWrapp = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  width: 410px;

  @media ${(p) => p.theme.breakpoints.mobile} {
    margin-top: ${getSpacing(1.5)};
    width: 100%;
    max-width: 290px;
    margin: 0;
    height: 100vh;
    overflow: hidden;
  }
`

export const SHeader = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${getSpacing(2)};
  background-color: ${(p) => p.theme.colors.grey_000};
  border-radius: ${(p) => p.theme.decoration.borderRadiusTop.default};
  max-width: 405px;
  width: 100%;
`

export const SFooter = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${getSpacing(2)};
  background-color: ${(p) => p.theme.colors.grey_000};
  border-radius: ${(p) => p.theme.decoration.borderRadiusBottom.default};
  max-width: 405px;
  width: 100%;
`

export const SBodyContent = styled.div`
  display: flex;
  background-color: ${(p) => p.theme.colors.grey_000};
  padding: ${getSpacing(1)};
  overflow-y: hidden;
  max-width: 405px;
  width: 100%;
`

export const SScrollableContent = styled.div`
  display: flex;
  max-width: 405px;
  width: 100%;
  overflow-y: scroll;
  border-radius: ${(p) => p.theme.decoration.borderRadius.default};
  flex-direction: column;
  gap: ${getSpacing(2)};
  align-items: stretch;
  background-color: ${(p) => p.theme.colors.grey_300};
  padding: ${getSpacing(1)};
  justify-content: flex-start;
  box-shadow: 0 0 3px ${(p) => opacityColor(p.theme.colors.grey_450, 0.5)};
  ${getDefaultBeatifiedScrollbar};
  background-color: ${(p) => p.theme.colors.grey_100};
  @media ${(p) => p.theme.breakpoints.mobile} {
    width: 100%;
  }
}
`
